import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { ReactNode } from 'react';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';

interface IconCellProps<R extends GridValidRowModel = any> {
  row: R;
  icon?: ReactNode;
}

export const IconCell = <R extends GridValidRowModel = any>({ icon }: IconCellProps<R>) => {
  return <>{icon ?? NULLISH_CELL_VALUE}</>;
};
